import { createAction } from 'typesafe-actions';
import * as actionTypes from './common.action-types';
import { EndGameStatus } from '../../../app/data/types/end-game-status';
import { GameInfo } from '../../../interface/main-menu/utils';

export const startGame = createAction(actionTypes.START_NEW_GAME)<GameInfo>();
export const gameStarted = createAction(actionTypes.GAME_STARTED)();

export const endGame = createAction(actionTypes.END_GAME)<EndGameStatus>();
